export default "__VITE_ASSET__DEb0xoGu__"